import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
  TemplateRef,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.less']
})
export class AlertModalComponent implements OnInit, AfterViewInit {

  @ViewChild('stringTpl')
  public stringTpl: TemplateRef<any>;

  @ViewChild('popupContent', { read: ViewContainerRef })
  public popupContent: ViewContainerRef;

  public Template: TemplateRef<any>;

  public Component: Type<any>;

  public Title: string = null;

  public Message: string;

  public ngClass: any = {};

  public CloseText: string = 'Close';

  public CanClose: boolean = true;

  @Output()
  public OnClose: EventEmitter<void>;

  constructor(public modal: BsModalRef) {
    this.OnClose = new EventEmitter();
  }

  public ngOnInit(): void {
  }

  public ngAfterViewInit(): void {
    this.popupContent.clear();

    if (this.Component) {
      const instance = this.popupContent.createComponent(this.Component);
      this.popupContent.insert(instance.hostView);
    } else if (this.Message && !this.Template) {
      this.popupContent.createEmbeddedView(this.stringTpl, {
        $implicit: {
          Message: this.Message,
          ngClass: this.ngClass
        }
      });
    } else if (this.Template && !this.Message) {
      this.popupContent.createEmbeddedView(this.Template);
    }
  }

  public Close(): void {
    this.OnClose.emit();

    if (this.CanClose) {
      this.modal.hide();
    }
  }

}
